import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { AppBar, Toolbar } from "@material-ui/core";
import { useTenantImage } from "@ploy-ui/tenants";
const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1
    },
    appBar: {
        boxShadow: "none"
    },
    link: {
        display: "inline-block",
        verticalAlign: "top",
        maxHeight: 100
    },
    logo: {
        textAlign: "center",
        flexGrow: 1
    },
    flag: {
        height: 100,
        maxWidth: "100%"
    },
    toolbar: {},
    banner: {
        height: 40,
        minHeight: 40,
        color: theme.palette.secondary.contrastText,
        background: theme.palette.secondary.main,
        width: "100%",
        fontSize: 18
    },
    info: {
        alignSelf: "flex-end",
        fontSize: 11
    },
    name: {
        fontWeight: "bold",
        textTransform: "uppercase"
    },
    logout: {
        fontWeight: "bold",
        textDecoration: "none"
    }
}), { name: "Header" });
const resolveUrl = (url) => url.replace("~", "").replace(/[^:]\/\//g, "/");
function Header(props) {
    const { showBanner, showInfo, homePage, userFullName, ...rest } = props;
    const classes = useStyles(props);
    const homeUrl = homePage && resolveUrl(homePage);
    const loginInfo = userFullName ? (_jsxs(Typography, { className: classes.info, children: ["Du er logget inn som ", _jsxs("span", { className: classes.name, children: [userFullName, " "] }), _jsx(Link, { to: "/logout", className: classes.logout, children: "Logg ut" })] })) : null;
    const headerLogo = useTenantImage("headerLogo");
    return (_jsxs(AppBar, { position: "static", ...rest, className: classes.appBar, children: [_jsxs(Toolbar, { className: classes.toolbar, children: [_jsx("div", { className: classes.logo, children: homeUrl ? (_jsx("a", { className: classes.link, href: homeUrl, children: _jsx("img", { className: classes.flag, src: headerLogo ?? undefined, alt: "Logo" }) })) : (_jsx("img", { className: classes.flag, src: headerLogo ?? undefined, alt: "Logo" })) }), showInfo && loginInfo] }), showBanner && (_jsx(Toolbar, { className: classes.banner, children: _jsx(Typography, { component: homeUrl ? "a" : Link, to: homeUrl ? undefined : "/", href: homeUrl ?? undefined, color: "inherit", children: _jsx("i", { className: "fa fa-home" }) }) }))] }));
}
export { Header };
//# sourceMappingURL=Header.js.map